import { useForm } from "react-hook-form";
import { useTranslation } from "react-i18next";
import { Sidebar, BaseButton, TextArea } from "@velocity-ehs/component-library";
import classes from "./PolicySidebar.module.scss";
import { SelectedRolePolicy } from "./RoleForm";
import { ScrollPanel } from "primereact/scrollpanel";
import classNames from "classnames";
import { useEffect } from "react";

interface Props {
  currentPolicy?: any;
  visible?: boolean;
  onHide?: () => void;
  selectedPolicy?: SelectedRolePolicy;
}

const PolicySidebar = ({ visible, onHide, selectedPolicy }: Props) => {
  const { t } = useTranslation();
  const cx = classNames.bind(classes);

  const { control, reset } = useForm<{ description: string }>({
    defaultValues: { description: "" },
  });

  useEffect(() => {
    if (selectedPolicy?.description) {
      reset({
        description: selectedPolicy?.description ?? "—",
      });
    }
  }, [selectedPolicy?.description, reset]);

  const footerButtons = () => {
    return (
      <>
        <BaseButton label={t("universal_close")} onClick={onHide} />
      </>
    );
  };

  const showAdditionalPolicies = () => {
    return (
      selectedPolicy?.scope?.name?.toLowerCase()?.includes("chem") &&
      selectedPolicy?.permissions?.length > 1
    );
  };

  const additionalPolicies = () => {
    return (
      <div className={classes.additionalPoliciesSection}>
        <ScrollPanel
          style={{ width: "100%", height: "100%" }}
          className={classes.policyScrollPanel}
        >
          {selectedPolicy?.permissions?.map((permission, index) => {
            return (
              <div key={index} className={classes.additionalPolicyCard}>
                <div
                  className={cx(classes.policyLabel, classes.marginBottom20)}
                >
                  {permission.displayName}
                </div>
                <div className={classes.additionalPolicyDescriptionLabel}>
                  {t("universal_Description")}
                </div>
                <div
                  className={cx(
                    classes.additionalPolicyDescription,
                    classes.gray45Text
                  )}
                >
                  {permission.description}
                </div>
              </div>
            );
          })}
        </ScrollPanel>
      </div>
    );
  };
  return (
    <Sidebar
      header={t("policy_details_title")}
      visible={visible}
      onHide={onHide}
      footer={footerButtons()}
    >
      <div className={classes.policySidebarWrapper}>
        <div
          className={cx(
            classes.capabilityTitle,
            classes.gray45Text,
            classes.marginBottom20
          )}
        >
          {selectedPolicy?.scope?.name}
        </div>
        <div className={cx(classes.policyName, classes.marginBottom20)}>
          {selectedPolicy?.name}
        </div>
        <form id="policy-form">
          <TextArea
            control={control}
            label={t("universal_policy_description")}
            name="description"
            readOnly
          />
        </form>
        {showAdditionalPolicies() ? (
          <>
            <div
              className={cx(classes.policyLabel, classes.marginBottom20)}
            >{`${t("policy_details_additional_policies")} (${
              selectedPolicy?.permissions.length ?? 0
            })`}</div>
            <div
              className={cx(
                classes.policyAssignmentBlurb,
                classes.marginBottom20
              )}
            >
              {t("policy_details_following_policies")}
            </div>
            {additionalPolicies()}
          </>
        ) : null}
      </div>
    </Sidebar>
  );
};

export { PolicySidebar };
